import React from "react";
import { SUPPORTED_LANGUAGES } from "../../constants";
import { updateLocale } from "../../lang";

const SupportLang = ({ mobile = false }) => {
  const SupportLanguages =
    JSON.parse(localStorage.getItem("supported_languages")) || [];

  // Get First Language from the Supported Languages and set it as the default language if no language is set
  React.useEffect(() => {
    if (!localStorage.getItem("locale_lang")) {
      updateLocale(SUPPORTED_LANGUAGES[SupportLanguages[0] || "en-US"].key);
    }
  }, [window.location.reload]);

  return (
    <div
      className={
        mobile
          ? "d-flex justify-content-center align-items-center gap-2 mx-auto"
          : "absolute d-flex justify-content-end align-items-center gap-2"
      }
      style={
        mobile
          ? { marginTop: 0, paddingLeft: 4, paddingRight: 4 }
          : { right: 20, marginTop: 10, marginRight: 10 }
      }
    >
      {SupportLanguages &&
        SupportLanguages?.length > 1 &&
        SupportLanguages.map((language) => {
          const { key, img, label } = SUPPORTED_LANGUAGES[language];
          return (
            <button
              key={language}
              onClick={() => {
                updateLocale(key);
              }}
              className="rounded-circle"
              style={{
                boxShadow: "0 3px 6px #0008",
              }}
            >
              <img
                src={img}
                alt={label}
                style={{
                  width: mobile ? 30 : 40,
                  height: mobile ? 30 : 40,
                }}
                title={label}
              />
            </button>
          );
        })}
    </div>
  );
};

export default SupportLang;
